import React, { useEffect, useState } from "react";
import Spinner from "../../Common/Spinner";
import { ProfileService } from "@/common/api/Services/Profile";
import MissionSlider from "../../Common/MissionSlider";
const ProfileMissions = ({ userId, userName }) => {
    const userFirstName = userName.split(" ")[0];
    const [profileMissions, setProfileMissions] = useState();
    const [pageStatus, setPageStatus] = useState("loading");
    const getProfileMissions = async () => {
        try {
            const res = await ProfileService.getProfileMissions(userId);
            setProfileMissions(res);
            setPageStatus("success");
        }
        catch {
            setPageStatus("error");
        }
    };
    useEffect(() => {
        getProfileMissions();
    }, []);
    if (pageStatus === "loading") {
        return (React.createElement("div", { className: "mt-5" },
            React.createElement(Spinner, null),
            ";"));
    }
    const sliderMissions = profileMissions.map((mission) => ({
        id: mission.id,
        name: mission.name,
        slug: mission.slug,
        groupName: mission.type == "group" ? mission.groupName : userName,
        type: mission.type,
        missionGoal: mission.missionGoal,
        startDate: mission.startDate,
        distanceUnit: mission.distanceUnit,
        isConqueror: mission.isConqueror,
        exerciseTypes: mission.exerciseTypes,
        imgAvatar: mission.imgAvatar,
        distancePct: mission.distancePct,
        isFundraising: mission.isFundraising,
        participantsCt: mission.participantsCt,
        isCompleted: mission.isCompleted,
        categoryId: mission.categoryId
    }));
    if (profileMissions && profileMissions.length < 0) {
        return (React.createElement("div", { className: "d-flex flex-column align-items-center my-5" },
            React.createElement("h2", null, "You have not started a mission yet."),
            React.createElement("div", { className: "my-4" },
                React.createElement("a", { href: "/start/new-mission", className: "bg-img-btn large-btn blue-img my-3" }, "START YOUR MISSION"))));
    }
    return (React.createElement("div", { className: "profile-container" },
        React.createElement("h2", { className: "text-center mb-3" },
            userFirstName,
            "'S",
            " ",
            React.createElement("span", { className: "secondary-color" }, "MISSIONS")),
        React.createElement(MissionSlider, { missions: sliderMissions })));
};
export default ProfileMissions;
